import {ButtonGroup, closeCurrentDialog} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useState} from 'react';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {CustomerSelectSearch, SaneCustomer} from '@dms/shared';

interface AssignCustomerDialogProps {
  onConfirm: (customerId: string) => void;
}

export function AssignCustomerDialog(props: AssignCustomerDialogProps) {
  const [selectedCustomer, setSelectedCustomer] = useState<SaneCustomer | null>(null);

  const handleConfirm = () => {
    if (isNil(selectedCustomer)) {
      return;
    }
    props.onConfirm(selectedCustomer.customerId);
  };

  return (
    <VStack spacing={4}>
      <CustomerSelectSearch type="customer" onCustomerSelect={setSelectedCustomer} />
      <ButtonGroup
        align="right"
        buttons={[
          {
            title: i18n.t('general.actions.cancel'),
            onClick: closeCurrentDialog,
            variant: 'secondary',
          },
          {
            title: i18n.t('general.actions.save'),
            onClick: handleConfirm,
            isDisabled: isNil(selectedCustomer),
          },
        ]}
      />
    </VStack>
  );
}
